'use strict';

const LOADING_STATE = {};

Object.defineProperties(LOADING_STATE, {
  LOADING: {enumerable: true, value: 0},
  LOADED: {enumerable: true, value: 1},
  NO_DATA: {enumerable: true, value: 2},
  NO_NETWORK: {enumerable: true, value: 3},
});

module.exports = LOADING_STATE;



// WEBPACK FOOTER //
// ./src/js/core-components/loading-icon/LOADING_STATES.js